import script from "./UserCreateAccessData.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreateAccessData.vue?vue&type=script&setup=true&lang=js"

import "./UserCreateAccessData.vue?vue&type=style&index=0&id=70251421&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70251421"]])

export default __exports__